
const buildStyles = (styleObj) => {
    
    const { styleType, valueStyle} = styleObj;
    const type = styleType.includes(':') ? styleType : `${styleType}:`;
    const value = valueStyle.includes(';') ? valueStyle : `${valueStyle};`;
    return `${type} ${value}`;
}

const parseStyles = (stylesString) => {
    
    const splitString = stylesString.split(" ");
    let styles = {};
    
    for (let i = 0; i < splitString.length; i += 2) {
        const styleType = splitString[i];
        const valueStyle = splitString[i + 1];
        
        styles = {
            ...styles,
            [styleType.slice(0, -1)]: buildStyles({styleType, valueStyle})
        }
    }

    return styles
}

module.exports = {
    parseStyles,
    buildStyles
}